import React from 'react';
import Button from '@ls/react-button';

const ThemedButton = props => (

    <Button
      {...props}
    />

);

ThemedButton.propTypes = {
};

export default ThemedButton;
